export const EventCoachActionTypes = {
    API_RESPONSE_SUCCESS: '@@event/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@event/API_RESPONSE_ERROR',

    LIST_EVENT_COACH: '@@event/LIST_EVENT_COACH',
    SHOW_EVENT_COACH: '@@event/SHOW_EVENT_COACH',
    UPDATE_EVENT_COACH: '@@event/UPDATE_EVENT_COACH',
    UPDATE_VIEWED_STATUS: '@@event/UPDATE_VIEWED_STATUS',
    FILTER_EVENT_COACH: '@@event/FILTER_EVENT_COACH',
};